import { apiClient, API_BASE_URL } from './apiClient';

const BASE = `${API_BASE_URL}/api/supplier-contacts`;

export const supplierContactsAPI = {
  async getAll(supplierId) {
    const query = supplierId ? `?supplier_id=${encodeURIComponent(supplierId)}` : '';
    return apiClient(`${BASE}/${query}`);
  },

  async create(data) {
    return apiClient(`${BASE}/`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  async update(id, data) {
    return apiClient(`${BASE}/${id}`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  async delete(id) {
    return apiClient(`${BASE}/${id}`, {
      method: 'DELETE',
    });
  },

  async bulkDelete(ids) {
    return apiClient(`${BASE}/bulk-delete`, {
      method: 'POST',
      body: JSON.stringify({ ids }),
    });
  },

  async bulkImport(contacts) {
    return apiClient(`${BASE}/bulk-import`, {
      method: 'POST',
      body: JSON.stringify({ contacts }),
    });
  },
};

export default supplierContactsAPI;
